import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Resume.css";

import IconButton from "./IconButton";
import HomeIcon from "./Icons/HomeIcon";
import DocumentsIcon from "./Icons/DocumentsIcon";
import DocumentsBigIcon from "./Icons/DocumentsBigIcon";
import PagosIcon from "./Icons/PagosIcon";
import DataIcon from "./Icons/DataIcon";

import GreyCard from "../GreyRectangles/GreyCard";
import InfoCard3 from "../GreyRectangles/InfoCard3";
import { LeftBoxTitle, LeftBoxSubTitle } from "../../../../styles/texts";
import { GrayButton } from "../../../../styles/buttons";
import DownloadAppQR from "../DownloadApp";
import Qr from "../Images/QR.png";
import DailyProdCard from "../Charts/DailyProdCard";
import BaseStatisticsCard from "../GreyRectangles/BaseStatisticsCard";
import PostInstalationStatisticsCard from "../GreyRectangles/PostInstalationStatisticsCard";
import { 
  SpecificBooking, 
  UserBooking, 
  UserData, 
  UserContract, 
  PostInstallationDocuments, 
  PostInstallationMedia, 
  ProductionData,
 } from "../../../../types/responseTypes";


type TabType = "inicio" | "data" | "pagos" | "documentos" ;

interface ResumeBarPostTerminoProps {
  specificBooking: SpecificBooking;
  userData: UserData;
  userBooking: UserBooking;
  userContract?: UserContract | null;
  bookingIndex: number;
  installationDocuments: PostInstallationDocuments | null;
  installationMedia: PostInstallationMedia | null;
  hourlyProductionData: ProductionData[] | null;
  dailyProductionData: ProductionData[] | null;
}

const ResumeBarPostTermino: React.FC<ResumeBarPostTerminoProps> = ({
  userData, 
  userBooking,
  specificBooking, 
  userContract, 
  bookingIndex,
  installationDocuments,
  installationMedia,
  hourlyProductionData,
  dailyProductionData,
}) => {

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabType>("inicio");
  const handleSetActiveTab = (tab: TabType) => { setActiveTab(tab) };

  const colors = {
    "Operativo": "#80BF80",
    "Parcial": "#EBCF4D",
    "En proceso de instalación": "#EBCF4D",
    "No operativo": "#FF0000",
  }

  const postInstalationStatistics = {
    status: "Operativo", // "Parcial" => circulo amarillo, "Operativo" => circulo verde (Otra cosa => rojo)
    statusIndicatorColor: colors["Operativo"],
    producing: specificBooking.totalAnnualGeneration, // kWh
    consuming: specificBooking.autoConsumption, // kWh
    description: "Tu casa está consumiendo energía de tus paneles",
  };

  let kWhVendidos = 279.61; // Datos para DailyProdCard: valores por defecto 
  let kWhConsumidos = 101.51; // Datos para DailyProdCard: valores por defecto
  let kWhVendidosMoney = 7610; // Datos para DailyProdCard: valores por defecto
  let kWhConsumidosMoney = 6000; // Datos para DailyProdCard: valores por defecto
  if (hourlyProductionData) {
    kWhVendidos = hourlyProductionData.reduce((sum, item) => sum + (item.dataItemMap.ongrid_power || 0), 0);
    const x1 = hourlyProductionData.reduce((sum, item) => sum + (item.dataItemMap.use_power || 0), 0);
    const x2 = hourlyProductionData.reduce((sum, item) => sum + (item.dataItemMap.selfProvide || 0), 0);
    kWhConsumidos = x1 + x2; //(?)
    kWhVendidosMoney = hourlyProductionData.reduce((sum, item) => sum + (item.dataItemMap.power_profit || 0), 0);
    kWhConsumidosMoney = kWhConsumidos * (kWhVendidosMoney / kWhVendidos); //(?)
    console.log("ResumeBarPostTermino - kWhVendidos", kWhVendidos, "kWhConsumidos", kWhConsumidos, x1, x2);
  }

  if (dailyProductionData) {
    kWhVendidos = dailyProductionData.reduce((sum, item) => sum + (item.dataItemMap.ongrid_power || 0), 0);
    const y1 = dailyProductionData.reduce((sum, item) => sum + (item.dataItemMap.use_power || 0), 0);
    const y2 = dailyProductionData.reduce((sum, item) => sum + (item.dataItemMap.selfProvide || 0), 0);
    kWhConsumidos = y1 + y2; //(?)
    kWhVendidosMoney = dailyProductionData.reduce((sum, item) => sum + (item.dataItemMap.power_profit || 0), 0);
    kWhConsumidosMoney = kWhConsumidos * (kWhVendidosMoney / kWhVendidos); //(?)
    console.log("ResumeBarPostTermino - kWhVendidos", kWhVendidos, "kWhConsumidos", kWhConsumidos, y1, y2);
  }

  
  
  /*
  stationCode: ID único de la planta.
  inverter_power: Potencia generada por el inversor (kWh).
  ongrid_power: Energía suministrada a la red (kWh).
  use_power: Energía consumida (kWh).
  power_profit: Beneficio económico generado (en la moneda especificada en el sistema).
  installed_capacity: Capacidad instalada (kW).
  */

  const findDocumentUrl = (where: string, name: string) => {
    // si name no es encontrado, retorna undefined y el boton deja de ser clickeable
    if (where === "installationDocs") {
      return installationDocuments?.installationDocuments.find(doc => doc.name === name)?.url;
    } else if (where === "contract") {
      return userContract?.documents.find(doc => doc.name === name)?.url;
    } 
    return undefined;
  };
  
  //const linkToPropuesta = `https://ruuf.cl/proposal/booking/${userBooking.bookingId}`; // Botón revisar propuesta
  //const linkToCredit = findDocumentUrl("contract", "contrato_creditu");
  const linkToPrenda = findDocumentUrl("contract", "prenda");
  const linkToPagare = findDocumentUrl("contract", "pagare");
  const linkToMandato = findDocumentUrl("contract", "mandato");
  const linkToCompraVenta = findDocumentUrl("contract", "compraventa");
  const linkToInverter = specificBooking.inverter.datasheetUrl; 
  const linkToPaneles = specificBooking.solarPanel.datasheetUrl;
  const linkToConnectionWithEnel = findDocumentUrl("installationDocs", 'Respuesta Solicitud de Conexión');
  const linkToCertificate = findDocumentUrl("installationDocs", ''); //"Ver documento Aprobación SEC"
  //console.log("ResumeBarPostTermino - USER CONTRACTS", userContract);
  //console.log("ResumeBarPostTermino - INSTALLATION DOCS", installationDocuments);
  const openLink = (link: string | undefined) => {
    console.log("ResumeBarPostTermino - openLink - link", link);
    if (link) {
      const formattedLink = link;//encodeURI(link);
      window.open(formattedLink, "_blank");
    }
  };

  
  return (
    <div>
      <div className="ResumeBar">
        <IconButton
          label="Inicio"
          icon={<HomeIcon />}
          isActive={activeTab === "inicio"}
          onClick={() => handleSetActiveTab("inicio")}
        />
        <IconButton
          label="Data"
          icon={<DataIcon />}
          isActive={activeTab === "data"}
          onClick={() => handleSetActiveTab("data")}
        />
        <IconButton
          label="Pagos"
          icon={<PagosIcon />}
          isActive={activeTab === "pagos"}
          onClick={() => handleSetActiveTab("pagos")}
        />
        <IconButton
          label="Documentos"
          icon={<DocumentsIcon />}
          isActive={activeTab === "documentos"}
          onClick={() => handleSetActiveTab("documentos")}
        />
      </div>

      <div>
        {activeTab === "inicio" && (
          <div className="justify-center">
            
            <BaseStatisticsCard specificBooking={specificBooking} />

            <PostInstalationStatisticsCard
              status={postInstalationStatistics.status}
              producing={postInstalationStatistics.producing}
              consuming={postInstalationStatistics.consuming}
              description={postInstalationStatistics.description}
              statusIndicatorColor={postInstalationStatistics.statusIndicatorColor}
            />

            <DailyProdCard 
              kWhVendidos={kWhVendidos}
              kWhVendidosMoney={kWhVendidosMoney}
              kWhConsumidos={kWhConsumidos}
              kWhConsumidosMoney={kWhConsumidosMoney}
            />

            <GreyCard>
              <div className="flex items-center justify-between w-full h-full gap-2 p-2">
                <div>
                  <LeftBoxTitle>Detalle de instalación</LeftBoxTitle>
                  <LeftBoxSubTitle>Aquí encontrarás más información sobre tu instalación</LeftBoxSubTitle>
                </div>
                <GrayButton
                  label="Ver instalación"
                  onClick={() => navigate("/home/installation", {
                    state: {
                      userData,
                      userBooking,
                      specificBooking,
                      userContract,
                      bookingIndex,
                      installationDocuments,
                      installationMedia,
                    },
                  })}
                  h="44px"
                />
              </div>
            </GreyCard>

            <DownloadAppQR
              title="Descarga la app"
              description="Escanea este código QR para descarga la app en tu celular y ver toda la información disponible"
              qrImage={Qr}
            />
          </div>
        )}

        {activeTab === "data" && (
          <DownloadAppQR
            title="Descarga la app"
            description="Escanea este código QR para descarga la app en tu celular y ver toda la información disponible"
            qrImage={Qr}
          />
        )}

        {activeTab === "pagos" && (
          <DownloadAppQR
            title="Descarga la app"
            description="Escanea este código QR para descarga la app en tu celular y ver toda la información disponible"
            qrImage={Qr}
          />
        )}

        {activeTab === "documentos" && (
          <div>
            {/* Agregar cada InfoCard según la imagen */}
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Compraventa"
              subtitle="Contrato"
              buttonText={ linkToCompraVenta ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToCompraVenta)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Mandato"
              subtitle="Contrato"
              buttonText={ linkToMandato ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToMandato)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Pagaré"
              subtitle="Contrato"
              buttonText="Ver"
              onButtonClick={() => openLink(linkToPagare)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Prenda"
              subtitle="Contrato"
              buttonText={ linkToPrenda ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToPrenda)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Aprobación SEC"
              subtitle="Certificado"
              buttonText={ linkToCertificate ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToCertificate)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Conexión con Enel"
              subtitle="Contrato"
              buttonText={ linkToConnectionWithEnel ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToConnectionWithEnel)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Paneles"
              subtitle="Ficha técnica"
              buttonText={ linkToPaneles ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToPaneles)}
            />
            <InfoCard3
              logo={<DocumentsBigIcon />}
              title="Inversor"
              subtitle="Ficha técnica"
              buttonText={ linkToInverter ? "Ver" : "No disp."}
              onButtonClick={() => openLink(linkToInverter)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ResumeBarPostTermino;
